import { Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-despacho-frameboard',
  templateUrl: './despacho-frameboard.component.html',
  styleUrls: ['./despacho-frameboard.component.scss']
})
export class DespachoFrameboardComponent implements OnInit {
    showSearch = false
    electronica = false
    reporte = false
    fisica = false
    showElectronica: boolean = false;
    idSede: any = '';
    @Input() GeneralSearchActive = false

    constructor(    @Inject(DOCUMENT) private document: Document,
    ) { }

    ngOnInit(): void {
        this.document.location.href.split('/').forEach(l => {
            if ( l === 'emision-fisica') {
                this.fisica = true
            } else if (l === 'emision-electronica') {
                this.electronica = true
            } else if (l === 'reportes-mensajeria') {
                this.reporte = true
            }
        })

        setTimeout(() => {
            this.verificarSede();
        }, 1000);
    }
   
    open() {
    }
    activar(l: string) {
        this.electronica = false
        this.fisica = false
        this.reporte = false

        if ( l === 'fisica') {
            this.fisica = true
        } else if (l === 'electronica') {
            this.electronica = true
        } else if (l === 'reporte') {
            this.reporte = true
        }
    }

    verificarSede(){
        const { idSede } = JSON.parse(localStorage.getItem('bandeja') || '{}');
        // Solo se habilita el modulo de mensajería electronica para la sede central
        if(idSede!=1){ this.showElectronica = false }else{ this.showElectronica = true }
    }
}
